export const GQL_SUBSTITUTES = `
    query(
        $alternativeGroupId: String!
        $size: Int
        $branch: String
        $deliveryDate: Date
        $itemIds: [String!]!
    ) {
        doSearchByAlternativeGroupId (
            alternativeGroupId: $alternativeGroupId
            size: $size
            branch: $branch
            deliveryDate: $deliveryDate
            itemIds: $itemIds
        ) {
        page {
            number
            size
            totalPages
            totalElements
        }
        results {
            uuid
            itemId
            itemName
            altItemGroupId
            alternativeItemFor
            delivery {
                price
                priceInc
                step
                max
                unitPriceDisplay
            }
            collection {
                price
                priceInc
                step
                max
                unitPriceDisplay
            }
            collectionMultiBuy {
                price
                priceInc
                step
                min
                max
                unitPriceDisplay
            }
            deliveryMultiBuy {
                price
                priceInc
                step
                min
                max
                unitPriceDisplay
            }
            quantityStep
            quantityMax
            productDescription
            offer {
                onOffer
                promoTypes
                promoTag
                promoTagId
                promoEnd
                promoDiscountText
                promoForCc
                promoDisAmt
                promoMinQty
                promoPrice
            }
            favourite
            imageLinks
            isAvailable
            tags
            price
        }
        facets {
            name
            data {
                id
                name
                qty
                unquery
                query
                selected
                counts {
                    id
                    name
                    qty
                    unquery
                    query
                    selected
                    counts {
                        id
                        name
                        qty
                        unquery
                        query
                        selected
                    }
                }
            }
        }
        }
    }
`;
